package com.hyperether.goodjob.scenes.register

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Icon
import androidx.compose.material.IconButton
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.back_arrow
import com.hyperether.goodjob.resources.chevron_left
import com.hyperether.goodjob.resources.email_address
import com.hyperether.goodjob.resources.email_format_not_valid
import com.hyperether.goodjob.resources.email_ic
import com.hyperether.goodjob.resources.forgot_your_password
import com.hyperether.goodjob.resources.no_worries
import com.hyperether.goodjob.resources.send_reset_link
import com.hyperether.goodjob.resources.your_email_address
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.components.verticalScrollbar
import com.hyperether.goodjob.theme.DarkGrey
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun ForgotPasswordView(
    onDismiss: () -> Unit,
    emailInput: MutableState<String>,
    onSendResetLink: () -> Unit
) {
    var emailNotValidError by remember { mutableStateOf(false) }

    Dialog(
        onDismissRequest = {

        },
        properties = DialogProperties(usePlatformDefaultWidth = false),
    ) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .background(Color.White)
                .verticalScroll(rememberScrollState())
                .disableMouseDragScrollOnWeb()
        ) {
            Column(
                modifier = Modifier
                    .padding(horizontal = 16.toScaleDp(), vertical = 16.toScaleDp())
                    .fillMaxWidth()
            ) {
                Image(
                    painter = painterResource(Res.drawable.back_arrow),
                    contentDescription = null,
                    modifier = Modifier.clickable {
                        onDismiss()
                    }
                )

                Text(
                    text = stringResource(Res.string.forgot_your_password),
                    fontSize = 24.toScaleSp(),
                    color = Color.Black,
                    fontWeight = FontWeight.Bold,
                    textAlign = TextAlign.Left,
                    modifier = Modifier.padding(top = 20.toScaleDp())
                )

                Text(
                    text = stringResource(Res.string.no_worries),
                    color = DarkGrey,
                    textAlign = TextAlign.Start,
                    fontSize = 16.toScaleSp(),
                    modifier = Modifier.padding(top = 10.toScaleDp())
                )

                Spacer(modifier = Modifier.height(10.toScaleDp()))

                SignInInputField(
                    text = emailInput.value,
                    onTextChanged = {
                        emailInput.value = it.trim()
                        emailNotValidError = false
                    },
                    isError = emailNotValidError && !isValidEmail(emailInput.value),
                    placeholder = stringResource(Res.string.your_email_address),
                    errorMessage = stringResource(Res.string.email_format_not_valid)
                )

                FilledButton(
                    onClick = {
                        if (!isValidEmail(emailInput.value)) {
                            emailNotValidError = true
                            return@FilledButton
                        }
                        onSendResetLink()
                    },
                    text = stringResource(Res.string.send_reset_link),
                    modifier = Modifier.padding(top = 30.toScaleDp()),
                    isEnabled = emailInput.value.isNotEmpty()
                )
            }
        }
    }
}

@Composable
fun ForgotPasswordWebView(
    onDismiss: () -> Unit,
    emailInput: MutableState<String>,
    onSendResetLink: () -> Unit
) {
    var emailNotValidError by remember { mutableStateOf(false) }

    Dialog(
        onDismissRequest = {

        },
        properties = DialogProperties(usePlatformDefaultWidth = false),
    ) {
        RegisterHolderView {
            val scrollState = rememberScrollState()

            Box(
                modifier = Modifier.fillMaxSize()
                    .padding(top = 32.toScaleDp(), start = 20.toScaleDp())
            ) {
                IconButton(
                    onClick = {
                        onDismiss()
                    },
                    modifier = Modifier
                        .align(Alignment.TopStart)
                        .size(24.toScaleDp())
                        .pointerHoverIcon(PointerIcon.Hand)
                ) {
                    Icon(
                        painter = painterResource(Res.drawable.chevron_left),
                        contentDescription = "Back",
                        modifier = Modifier.size(20.toScaleDp())
                    )
                }

                Box(
                    modifier = Modifier
                        .fillMaxSize()
                        .padding(
                            bottom = 30.toScaleDp(),
                            start = 80.toScaleDp(),
                            end = 100.toScaleDp()
                        ),
                    contentAlignment = Alignment.Center
                ) {
                    Column(
                        modifier = Modifier.fillMaxHeight()
                            .verticalScrollbar(scrollState)
                            .verticalScroll(scrollState)
                            .disableMouseDragScrollOnWeb(),
                        verticalArrangement = Arrangement.Center
                    ) {
                        Text(
                            text = stringResource(Res.string.forgot_your_password),
                            fontSize = 28.toScaleSp(),
                            color = Color.Black,
                            fontWeight = FontWeight.Bold,
                            textAlign = TextAlign.Center,
                            maxLines = 2,
                            overflow = TextOverflow.Ellipsis
                        )
                        Spacer(modifier = Modifier.height(4.toScaleDp()))
                        Text(
                            text = stringResource(Res.string.no_worries),
                            color = DarkGrey,
                            textAlign = TextAlign.Center,
                            fontSize = 16.toScaleSp(),
                            fontWeight = FontWeight.W400,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                        Spacer(modifier = Modifier.height(32.toScaleDp()))
                        RegisterInputFieldWeb(
                            text = emailInput.value,
                            onTextChanged = {
                                emailInput.value = it.trim()
                                emailNotValidError = false
                            },
                            isError = emailNotValidError && !isValidEmail(emailInput.value),
                            placeholder = stringResource(Res.string.email_address),
                            drawableResource = Res.drawable.email_ic,
                            errorMessage = stringResource(Res.string.email_format_not_valid)
                        )
                        Spacer(modifier = Modifier.height(24.toScaleDp()))
                        FilledButton(
                            onClick = {
                                if (!isValidEmail(emailInput.value)) {
                                    emailNotValidError = true
                                    return@FilledButton
                                }
                                onSendResetLink()
                            },
                            text = stringResource(Res.string.send_reset_link),
                            isEnabled = emailInput.value.isNotEmpty()
                        )
                    }
                }
            }
        }
    }
}